import verificarDadosUsuarioLogadoMixin from '@/mixins/verificarDadosUsuarioLogadoMixin';
import { ErrosCadastroExterno } from '@/plugins/constants';

<template>
    <v-container class="form-container">
        <h1 class="text-center">{{ mensagem }}</h1>
    </v-container>
</template>

<script>

  import { ErrosCadastroExterno } from '@/plugins/constants'
  export default {
    name: 'AutenticaUsuario',
    data () {
      return {
        mensagem: 'Autenticando usuário...',
        flavor: ''
      }
    },
    mounted () {
      this.$session.destroy()

      const route_params = this.$route.params
      if (route_params.sucesso_no_formulario) {
        this.mensagem = ErrosCadastroExterno.ERRO_PROCESSANDO_USUARIO
      } else if (route_params.falha_no_formulário) {
        this.mensagem = ErrosCadastroExterno.ERRO_AUTO_CADASTRO
      } else if (route_params.vem_do_cadastro) {
        this.mensagem = ErrosCadastroExterno.ERRO_SESSAO_INVALIDADA
      } else {
        const params = this.$route.query
        const nome_empresa = params.N
        const client_id = params.I
        const client_secret = params.S
        const cpf = params.U

        this.$http.get(`/permitido_auto_cadastro?N=${nome_empresa}&I=${client_id}&S=${client_secret}&U=${cpf}`).then(response => {
          this.flavor = response.data.flavor
          this.redirecionaUsuarioParaTelaDeCadastro(nome_empresa, client_id, client_secret, cpf, this.flavor)
        }).catch((error) => {
          this.mensagem = error.response.data.Msg_Erro
        })
      }
    },
    methods: {
      redirecionaUsuarioParaTelaDeCadastro (nome_empresa, client_id, client_secret, cpf, flavor) {
        this.$router.push({ name: 'cadastro_usuario_externo', params: { nome_empresa, client_id, client_secret, cpf, flavor } })
      }
    }
  }
</script>

<style scoped lang="scss">

</style>
